import styled from 'styled-components';

export const SectionWrapper = styled.div`
    margin: 0 16px;
    background: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
`;
